export default __webpack_public_path__ + "static/media/case_07.0a403fbf.jpg";